import { Component, input, ChangeDetectionStrategy, booleanAttribute } from '@angular/core';
import { PreloaderComponent } from '../preloader/preloader.component';
import { IconComponent, IconName } from '@/components/icon/icon.component';


@Component({
  selector: 'tc-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PreloaderComponent,
    IconComponent,
  ],
})
export class ButtonComponent {
  readonly leftIconName = input<IconName | null>(null);
  readonly rightIconName = input<IconName | null>(null);

  buttonType = input<'button' | 'submit'>('button');
  buttonSize = input<'small' | 'normal' | 'large'>('normal');

  isTransparent = input<boolean>(false, { transform: booleanAttribute });
  isStyleDefault = input<boolean>(false, { transform: booleanAttribute });
  isBold = input<boolean>(false, { transform: booleanAttribute });

  isDisabled = input<boolean>(false, { transform: booleanAttribute });
  isLoading = input<boolean>(false, { transform: booleanAttribute });
  isDisabledOnLoading = input<boolean>(true, { transform: booleanAttribute });
}
